// Identity headers for platform APIs; brand-scoped calls also send the brand.
export const platformHeaders = (platformId: string, brandId?: string | number | null) => ({
  'x-platform-id': platformId,
  ...(brandId !== undefined && brandId !== null && brandId !== ''
    ? { 'x-brand-id': String(brandId) }
    : {}),
})
